import "../Style/Gdstack.css";

import figmaImg from "../assets/figma.png";
import adobeImg from "../assets/adobe.png";
import psImg from "../assets/ps.png";
import aiImg from "../assets/ai.png";
import xdImg from "../assets/xd.png";
import sketchImg from "../assets/sketch.png";
import miroImg from "../assets/miro.png";
import framerImg from "../assets/framer.png";

/* VALUE BOX ICONS */
import commitmentImg from "../assets/commitment.png";
import excellenceImg from "../assets/excellence.png";
import passionImg from "../assets/passion.png";
import priorityImg from "../assets/priority.png";

const tools = [
  { src: sketchImg, alt: "Sketch" },
  { src: miroImg, alt: "Miro" },
  { src: framerImg, alt: "Framer" },
  { src: figmaImg, alt: "Figma" },
  { src: xdImg, alt: "Adobe XD" },
  { src: psImg, alt: "Photoshop" },
  { src: aiImg, alt: "Illustrator" },
  { src: adobeImg, alt: "Adobe" },
];

export default function GdStack() {
  const items = [...tools, ...tools];

  return (
    <section className="gdstack-stack-section">
      <div className="gdstack-stack-pattern" aria-hidden="true" />

      <div className="gdstack-stack-inner">
        <div className="gdstack-stack-badge">
          <div className="gdstack-stack-badge-ring" aria-hidden="true" />
          <h2 className="gdstack-stack-badge-title">Design Stack</h2>
          <span className="gdstack-stack-badge-subtitle">
            Graphic Design Tools
          </span>
        </div>

        <div className="gdstack-stack-right">
          <span className="gdstack-stack-eyebrow">
            Tools &amp; Technology
          </span>

          <h3 className="gdstack-stack-info-heading">
            Our Graphic Design Tech Stack
          </h3>

          <p className="gdstack-stack-info-desc">
            We create visually compelling graphic designs that strengthen
            your brand identity and communication. Our creative visuals
            help attract attention, engage audiences, and elevate your
            brand presence.
          </p>

          <div className="gdstack-stack-marquee-card">
            <div className="gdstack-stack-marquee-outer">
              <div className="gdstack-stack-marquee-track">
                {items.map((tool, i) => (
                  <div className="gdstack-stack-cell" key={i}>
                    <div className="gdstack-stack-icon-wrap">
                      <img
                        src={tool.src}
                        alt={tool.alt}
                        className="gdstack-stack-icon"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BLUE VALUE BOX */}
      <div className="gdstack-value-wrapper">
        <div className="gdstack-value-box">
          <div className="gdstack-value-card">
            <img
              src={commitmentImg}
              alt="Commitment"
              className="gdstack-value-image"
            />
            <h4 className="gdstack-value-title">Commitment</h4>
            <p className="gdstack-value-desc">
              We don't stop until we reach our goals.
            </p>
          </div>

          <div className="gdstack-value-card">
            <img
              src={excellenceImg}
              alt="Excellence"
              className="gdstack-value-image"
            />
            <h4 className="gdstack-value-title">Excellence</h4>
            <p className="gdstack-value-desc">
              We don't settle for less, as we have set our standards high.
            </p>
          </div>

          <div className="gdstack-value-card">
            <img
              src={passionImg}
              alt="Passion"
              className="gdstack-value-image"
            />
            <h4 className="gdstack-value-title">Passion</h4>
            <p className="gdstack-value-desc">
              We go beyond to develop tools that empower customers.
            </p>
          </div>

          <div className="gdstack-value-card">
            <img
              src={priorityImg}
              alt="Priority"
              className="gdstack-value-image"
            />
            <h4 className="gdstack-value-title">Priority</h4>
            <p className="gdstack-value-desc">
              Customers are our top priority. Customer satisfaction is our
              goal.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}